const ReactAppStage = process.env.REACT_APP_API_STAGE;
const configuredEndpoint = process.env.REACT_APP_API_ENDPOINT?.trim();
const remoteEndpoint =
  ReactAppStage == "Live"
    ? "https://rioinsightsapi.riolabz.com/v1/"
    : "https://feedbacksystem.api.riolabz.com/v1/";
    // : "http://localhost:4409/v1/";

const dev = {
  API_ENDPOINT_URL: configuredEndpoint || remoteEndpoint,
};

const prod = {
  API_ENDPOINT_URL: configuredEndpoint || remoteEndpoint,
};

const test = {
  API_ENDPOINT_URL: configuredEndpoint || remoteEndpoint,
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
